import { createSlice } from "@reduxjs/toolkit";
import {
  createProject,
  fetchProjects,
  fetchProject,
  updateProject,
  deleteProject,
  createTask,
  fetchTasks,
  updateTask,
  deleteTask,
  addTaskComment,
  fetchProjectAnalytics,
} from "./projectManagement.action";

const initialState = {
  projects: [],
  tasks: [],
  analytics: null,
  loading: false,
  error: null,
  selectedProject: {},
};

const projectManagementSlice = createSlice({
  name: "projectManagement",
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.projects = action.payload?.data || [];
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch projects";
      })
      .addCase(fetchProject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProject.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedProject = action.payload?.data || {};
      })
      .addCase(fetchProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch Project";
      })

      .addCase(createProject.pending, (state) => {
        state.loading = true;
      })
      .addCase(createProject.fulfilled, (state, action) => {
        state.loading = false;
        // state.projects = action.payload?.data
      })
      .addCase(createProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to create project";
      })

      .addCase(updateProject.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProject.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedProject = action.payload?.data || {};
      })
      .addCase(updateProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to update project";
      })

      .addCase(deleteProject.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteProject.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to delete project";
      })
      //task
      .addCase(fetchTasks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks = action.payload?.data || [];
      })
      .addCase(fetchTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch tasks";
      })

      .addCase(createTask.pending, (state) => {
        state.loading = true;
      })
      .addCase(createTask.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to create task";
      })

      .addCase(updateTask.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTask.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedProject = action.payload?.data || {};
      })
      .addCase(updateTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to update task";
      })

      .addCase(deleteTask.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTask.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to delete task";
      })

      .addCase(addTaskComment.pending, (state) => {
        state.loading = true;
      })
      .addCase(addTaskComment.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedProject = action.payload?.data;
      })
      .addCase(addTaskComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to delete task";
      })
      .addCase(fetchProjectAnalytics.pending, (state) => {
        state.analyticsLoading = true;
      })
      .addCase(fetchProjectAnalytics.fulfilled, (state, action) => {
        state.analyticsLoading = false;
        state.analytics = action.payload;
      })
      .addCase(fetchProjectAnalytics.rejected, (state, action) => {
        state.analyticsLoading = false;
        state.error = action.payload?.message || "Failed to fetch analytics";
      });
  },
});

export const { clearMessages } = projectManagementSlice.actions;
export default projectManagementSlice.reducer;
